import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import throttle from 'lodash/throttle';

import { apiConfig, COOKIE_NAME } from 'config';
import { displayNotifications, isMobileDeviceRequest, getCookie } from 'lib';

const useLiveVisitors = () => {
    const propertyID = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyID
    );
    const widgetReady = useSelector(
        (state) => state.miniBookingWidget.widgetReady
    );

    const isMobileDevice = isMobileDeviceRequest();
    const cookie = getCookie(COOKIE_NAME);

    const onMove = throttle(async (event) => {
        const userAgent = window.navigator.userAgent;

        try {
            const response = await axios.post(apiConfig?.liveVisitorsUrl, {
                cookie,
                mobile: isMobileDevice,
                propertyID,
                url: window.location.href,
                userAgent,
            });
            const notifications = response.data.notifications || [];
            displayNotifications(notifications);
        } catch (error) {}
    }, 3000);

    useEffect(() => {
        if (!widgetReady) {
            return;
        }

        const body = document.querySelector('body');

        if (isMobileDevice) {
            body.addEventListener('touchmove', onMove);

            return () => {
                body.removeEventListener('touchmove', onMove);
            };
        } else {
            body.addEventListener('mousemove', onMove);
            return () => {
                body.removeEventListener('mousemove', onMove);
            };
        }
    }, [widgetReady]);
};

export default useLiveVisitors;
